import { createContext, ReactNode, useContext } from "react";
import { ModuleId } from "@cerberus/modules";
import { getEnabledModuleIds } from "./activeModules";

const EnabledModulesContext = createContext<ModuleId[]>(getEnabledModuleIds());

/**
 * Provides the set of enabled module ids to the component tree. Enablement is
 * fixed per deployment, so it's resolved once.
 */
export function ModulesProvider({ children }: { children: ReactNode }) {
  return (
    <EnabledModulesContext.Provider value={getEnabledModuleIds()}>
      {children}
    </EnabledModulesContext.Provider>
  );
}

export function useEnabledModules(): ModuleId[] {
  return useContext(EnabledModulesContext);
}

export function useModuleEnabled(id: ModuleId): boolean {
  return useEnabledModules().includes(id);
}

/** Renders children only when the given module is enabled for this deployment. */
export function IfModule({
  id,
  children,
}: {
  id: ModuleId;
  children: ReactNode;
}) {
  return useModuleEnabled(id) ? <>{children}</> : null;
}
